export class MeasurementListLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            no: lang.measurement[110],
            description: lang.measurement[0],
            brand: lang.measurement[1],
            model: lang.measurement[2],
            dateofpurchase: lang.measurement[3],
            internalCode: lang.measurement[4],
            serialNumber: lang.measurement[5],
            location: lang.measurement[6],
            documentAttachment: lang.measurement[7],
            measuringRange: lang.measurement[8],
            maxallowedError: lang.measurement[10],
            activeCalibrationplans: lang.measurement[121],
            responsible: lang.measurement[123],
            photo: lang.measurement[12],
            action: lang.measurement[13],
            resolution: lang.measurement[146],
            calibrationStatus: lang.measurement[147],
            typeofCalibration: lang.measurement[148],
            instrumentStatus: lang.measurement[149],
            internal: lang.measurement[150],
            external: lang.measurement[151],
            list: lang.measurement[137],
            erase: lang.general[4],
            modify: lang.general[2],
            view: lang.general[3],
            duplicate: lang.general[8],
            active: lang.measurement[31],
            decommissioned: lang.measurement[32],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            activeColumns: lang.general[11],
            close: lang.general[17],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            exportPrint: lang.general[16],
            save: lang.general[0],
            measurementTools: lang.measurement[33],
            listofmeasurementTools: lang.general[48],
            requiredField: lang.measurement[98],
            planCode: lang.measurement[119],
            repetitions: lang.measurement[80],
            daysnotify: lang.measurement[62],
            notification_time: lang.measurement[90],
            equipment_to_which_the_plan_applies: lang.measurement[126],
            calibrationplans: lang.measurement[125],
            copyallSelected: lang.measurement[133],
            areyousuretodelete: lang.measurement[131],
            calibrationdeleteconfirm: lang.measurement[153],
            createcalibrationplan: lang.measurement[122],
            howoftentorepeat: lang.measurement[127],
            notificationtime: lang.measurement[90],
            reference_email: lang.measurement[52],
            select: lang.measurement[128],
            selectTime: lang.measurement[129],
            withoutsaving: lang.measurement[132],
            plancodealreadyexists: lang.measurement[154],
            pleaseenteronlydigits: lang.measurement[155],
            daysnotifys: lang.measurement[156],           
            correctemail: lang.measurement[157],
            calibration_planning: lang.measurement[138],
            type_of_calibration: lang.measurement[148],
            search: lang.general[33],
            instruction_desc: lang.measurement[135],
            days_left: lang.measurement[50],
            execution_date: lang.measurement[55],
            plan_desc: lang.measurement[136],
            plan_code: lang.measurement[119],

        }

    }

    lang() {
        return this.variables;
    }

}


export class MeasurementCreateListLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            no: lang.measurement[110],
            description: lang.measurement[0],
            photo: lang.measurement[12],
            brand: lang.measurement[1],
            model: lang.measurement[2],
            dateofPurchase: lang.measurement[3],
            internalCode: lang.measurement[4],
            serialNumber: lang.measurement[5],
            location: lang.measurement[6],
            documentAttachment: lang.measurement[7],
            measuringRange: lang.measurement[8],
            degreeofPrecision: lang.measurement[9],
            maxallowedError: lang.measurement[10],
            resolution: lang.measurement[146],
            responsible: lang.measurement[123],
            typeofCalibration: lang.measurement[148],
            createMeasurement: lang.measurement[30],
            requiredField: lang.measurement[98],

        }

    }

    lang() {
        return this.variables;
    }

}

export class MeasurementViewLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            no: lang.measurement[110],
            description: lang.measurement[0],
            brand: lang.measurement[1],
            model: lang.measurement[2],
            dateofpurchase: lang.measurement[3],
            internalCode: lang.measurement[4],
            serialNumber: lang.measurement[5],
            location: lang.measurement[6],
            documentAttachment: lang.measurement[7],
            measuringRange: lang.measurement[8],
            maxallowedError: lang.measurement[10],
            activeCalibrationplans: lang.measurement[121],
            responsible: lang.measurement[123],
            state: lang.measurement[11],
            photo: lang.measurement[12],
            action: lang.measurement[13],
            resolution: lang.measurement[146],
            calibrationStatus: lang.measurement[147],
            typeofCalibration: lang.measurement[148],
            instrumentStatus: lang.measurement[149],
            internal: lang.measurement[150],
            external: lang.measurement[151],
            list: lang.measurement[137],
            erase: lang.general[4],
            search: lang.general[33],
            modify: lang.general[2],
            view: lang.general[3],
            duplicate: lang.general[8],
            active: lang.measurement[31],
            decommissioned: lang.measurement[32],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            activeColumns: lang.general[11],
            close: lang.general[17],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            exportPrint: lang.general[16],
            save: lang.general[0],
            measurementTools: lang.measurement[33],
            listofmeasurementTools: lang.general[48],
            requiredField: lang.measurement[98],
            generalData: lang.measurement[14],
            calibrations: lang.measurement[15],
            extraordinaryData: lang.measurement[16],
            planCode: lang.measurement[119],
            repetitions: lang.measurement[80],
            daysnotify: lang.measurement[62],
            notification_time: lang.measurement[64],
            planStartingdate: lang.measurement[152],
            activatePlan: lang.measurement[140],
            deactivatePlan: lang.measurement[141],
            enterStartdate: lang.measurement[142],
            dateofIntervention: lang.measurement[23],
            performer: lang.measurement[24],
            outcome: lang.measurement[25],
            notes: lang.measurement[26],
            cost: lang.measurement[27],
            aresuredel: lang.measurement[130],
            positive: lang.measurement[70],
            negative: lang.measurement[71],
            attachments: lang.measurement[51],
            statistics: lang.measurement[158],
            
        }

    }

    lang() {
        return this.variables;
    }

}


export class MeasurementOrdinaryLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            no: lang.measurement[110],
            description: lang.measurement[0],
            brand: lang.measurement[1],
            model: lang.measurement[2],
            dateofpurchase: lang.measurement[3],
            internalCode: lang.measurement[4],
            serialNumber: lang.measurement[5],
            location: lang.measurement[6],
            documentAttachment: lang.measurement[7],
            measuringRange: lang.measurement[8],
            maxallowedError: lang.measurement[10],
            activeCalibrationplans: lang.measurement[121],
            responsible: lang.measurement[123],
            state: lang.measurement[11],
            photo: lang.measurement[12],
            action: lang.measurement[13],
            resolution: lang.measurement[146],
            calibrationStatus: lang.measurement[147],
            typeofCalibration: lang.measurement[148],
            instrumentStatus: lang.measurement[149],
            internal: lang.measurement[150],
            external: lang.measurement[151],
            list: lang.measurement[137],
            erase: lang.general[4],
            modify: lang.general[2],
            view: lang.general[3],
            duplicate: lang.general[8],
            active: lang.measurement[31],
            decommissioned: lang.measurement[32],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            activeColumns: lang.general[11],
            close: lang.general[17],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            exportPrint: lang.general[16],
            save: lang.general[0],
            measurementTools: lang.measurement[33],
            listofmeasurementTools: lang.general[48],
            requiredField: lang.measurement[98],
            generalData: lang.measurement[14],
            calibrations: lang.measurement[15],
            extraordinaryData: lang.measurement[16],
            planCode: lang.measurement[119],
            repetitions: lang.measurement[80],
            daysnotify: lang.measurement[62],
            notification_time: lang.measurement[64],
            planStartingdate: lang.measurement[152],
            activatePlan: lang.measurement[140],
            deactivatePlan: lang.measurement[141],
            enterStartdate: lang.measurement[142],
            executionDate: lang.measurement[55],
            performer: lang.measurement[24],
            outcome: lang.measurement[25],
            notes: lang.measurement[26],
            option: lang.measurement[56],
            nextintervention: lang.measurement[54],
            referringDate: lang.measurement[91],
            cost: lang.measurement[27],
            attachments: lang.measurement[51],
            insertOrdinaryMaintenance: lang.measurement[145],
            nextDeadline: lang.measurement[57],
            referringDeadline: lang.measurement[58],

        }

    }

    lang() {
        return this.variables;
    }

}
